import React, { useEffect, useState, useRef, useContext } from "react";
import "./ExteriorInteriorAccessories.css";

import exterior1 from "../../../../assets/images/mhero1/exterior/ex1.webp";
import exterior2 from "../../../../assets/images/mhero1/exterior/ex2.webp";
import exterior3 from "../../../../assets/images/mhero1/exterior/ex3.jpg";
import exterior4 from "../../../../assets/images/mhero1/exterior/ex4.webp";
import exterior5 from "../../../../assets/images/mhero1/exterior/ex5.png";
import exterior6 from "../../../../assets/images/mhero1/exterior/ex6.png";

import interior1 from "../../../../assets/images/mhero1/interior/int1.webp";
import interior2 from "../../../../assets/images/mhero1/interior/int2.webp";
import interior3 from "../../../../assets/images/mhero1/interior/int3.webp";
import interior4 from "../../../../assets/images/mhero1/interior/int4.webp";
import interior5 from "../../../../assets/images/mhero1/interior/int5.webp";
import interior6 from "../../../../assets/images/mhero1/interior/int6.webp";

import accessories1 from "../../../../assets/images/mhero1/accessories/ac1.webp";
import accessories2 from "../../../../assets/images/mhero1/accessories/ac2.webp";
import accessories3 from "../../../../assets/images/mhero1/accessories/ac3.webp";
import accessories4 from "../../../../assets/images/mhero1/accessories/ac4.webp";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const EXTERIOR_IMAGES = [
  exterior1,
  exterior2,
  exterior3,
  exterior4,
  exterior5,
  exterior6,
];

const INTERIOR_IMAGES = [
  interior1,
  interior2,
  interior3,
  interior4,
  interior5,
  interior6,
];

const ACCESSORIES_IMAGES = [
  accessories1,
  accessories2,
  accessories3,
  accessories4,
];

const Slider = ({ title, images }) => {
  const [index, setIndex] = useState(0);

  const startX = useRef(null);
  const isDragging = useRef(false);

  if (!images || images.length === 0) return null;

  const prev = () =>
    setIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );

  const next = () =>
    setIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );

  const threshold = 60;

  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (!startX.current) return;

    const endX = e.changedTouches[0].clientX;
    const diff = startX.current - endX;

    if (diff > threshold) next();
    if (diff < -threshold) prev();

    startX.current = null;
  };

  const handleMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.clientX;
  };

  const handleMouseUp = (e) => {
    if (!isDragging.current) return;

    const endX = e.clientX;
    const diff = startX.current - endX;

    if (diff > threshold) next();
    if (diff < -threshold) prev();

    isDragging.current = false;
    startX.current = null;
  };

  const handleMouseLeave = () => {
    isDragging.current = false;
    startX.current = null;
  };

  return (
    <section dir="ltr" className="gallery-section">
      <h2 className="gallery-title">{title}</h2>
      <span className="gallery-line" />

      <div
        className="slider"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
      >
        <img
          src={images[index]}
          alt={title}
          className="slide-image"
          draggable="false"
        />

        <button className="arrow left" onClick={prev}>
          ‹
        </button>
        <button className="arrow right" onClick={next}>
          ›
        </button>

        <div className="dots">
          {images.map((_, i) => (
            <span
              key={i}
              className={`dot ${i === index ? "active" : ""}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const ExteriorInteriorAccessories = () => {
  const { currentLang } = useContext(LanguageContext);

  const [titles, setTitles] = useState({
    exterior_title: "Exterior",
    interior_title: "Interior",
    accessories_title: "Accessories",
  });

  useEffect(() => {
    const loadGalleryText = async () => {
      try {
        const response = await getPageContent("mhero1", currentLang);
        const gallery = response.sections?.gallery;

        if (gallery) {
          setTitles({
            exterior_title: gallery.exterior_title || "Exterior",
            interior_title: gallery.interior_title || "Interior",
            accessories_title: gallery.accessories_title || "Accessories",
          });
        }
      } catch (err) {
        console.error("Failed to load MHERO1 gallery text", err);
      }
    };

    loadGalleryText();
  }, [currentLang]);

  return (
    <div className="gallery-wrapper">
      <Slider title={titles.exterior_title} images={EXTERIOR_IMAGES} />
      <Slider title={titles.interior_title} images={INTERIOR_IMAGES} />
      <Slider title={titles.accessories_title} images={ACCESSORIES_IMAGES} />
    </div>
  );
};

export default ExteriorInteriorAccessories;
